import axios from 'axios';

// Determine API URL based on current hostname
function getApiBaseUrl(): string {
    // Check environment variable first
    if (import.meta.env.VITE_API_URL) {
        return import.meta.env.VITE_API_URL;
    }

    // Auto-detect based on hostname
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

    if (hostname.includes('staging.amlich.info.vn') || hostname.includes('lunar-calendar-staging.pages.dev')) {
        return 'https://staging-api.amlich.info.vn';
    }

    if (hostname.includes('amlich.info.vn') || hostname.includes('lunar-calendar.pages.dev')) {
        return 'https://api.amlich.info.vn';
    }

    // Default to localhost for development
    return 'http://localhost:8080';
}

const API_BASE_URL = getApiBaseUrl();

export const api = axios.create({
    baseURL: `${API_BASE_URL}/api/v1`,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add device ID header for anonymous users
api.interceptors.request.use((config) => {
    const deviceId = getDeviceId();
    config.headers['X-Device-ID'] = deviceId;
    return config;
});

// Generate or get device ID from localStorage
function getDeviceId(): string {
    const key = 'lunar_calendar_device_id';
    let deviceId = localStorage.getItem(key);
    if (!deviceId) {
        deviceId = `device_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        localStorage.setItem(key, deviceId);
    }
    return deviceId;
}

// Error interceptor
api.interceptors.response.use(
    (response) => response,
    (error) => {
        console.error('API Error:', error.response?.data || error.message);
        return Promise.reject(error);
    }
);

export default api;
